import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { dbApi, type ExecResult, type QueryResult } from '@/api/dbviewer'

export function useDatabases() {
  return useQuery({
    queryKey: ['db-databases'],
    queryFn: dbApi.databases,
  })
}

export function useTables(service: string | undefined) {
  return useQuery({
    queryKey: ['db-tables', service],
    queryFn: () => dbApi.tables(service!),
    enabled: !!service,
  })
}

export function useDBQuery() {
  return useMutation({
    mutationFn: ({
      service,
      sql,
      limit,
    }: {
      service: string
      sql: string
      limit?: number
    }): Promise<QueryResult> => dbApi.query(service, sql, limit),
  })
}

export function useDBExecute() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ service, sql }: { service: string; sql: string }): Promise<ExecResult> =>
      dbApi.execute(service, sql),
    onSuccess: (_res, vars) => {
      // Tables list reflects row counts, so refresh it after mutations.
      qc.invalidateQueries({ queryKey: ['db-tables', vars.service] })
    },
  })
}
